export interface GamePreferences {
  readonly sound: boolean;
  readonly music: boolean;
  readonly raining: boolean;
  readonly screaming: boolean;
  readonly notifier: boolean;
  readonly showFps: boolean;
  readonly oldTextures: boolean;
  readonly gamepads: boolean;
  readonly saveWinner: boolean;
}

export const DEFAULT_GAME_PREFERENCES: GamePreferences = Object.freeze({
  sound: true,
  music: true,
  raining: true,
  screaming: true,
  notifier: true,
  showFps: false,
  oldTextures: false,
  gamepads: true,
  saveWinner: true
});

export const normalizeGamePreferences = (value: unknown): GamePreferences => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return DEFAULT_GAME_PREFERENCES;
  const input = value as Partial<Record<keyof GamePreferences, unknown>>;
  return Object.fromEntries(Object.entries(DEFAULT_GAME_PREFERENCES).map(([key, fallback]) => [key, typeof input[key as keyof GamePreferences] === "boolean" ? input[key as keyof GamePreferences] : fallback])) as unknown as GamePreferences;
};
